/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class IconsService extends __BaseService {
  static readonly IconsGetIconPath = '/icons/{iconId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the requested icon
   * @param params The `IconsService.IconsGetIconParams` containing the following parameters:
   *
   * - `size`: The desired size of the icon
   *
   * - `iconId`: GUID of the requested icon
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  IconsGetIconResponse(params: IconsService.IconsGetIconParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.size != null) __params = __params.set('size', params.size.toString());

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/icons/${encodeURIComponent(String(params.iconId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Returns the requested icon
   * @param params The `IconsService.IconsGetIconParams` containing the following parameters:
   *
   * - `size`: The desired size of the icon
   *
   * - `iconId`: GUID of the requested icon
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  IconsGetIcon(params: IconsService.IconsGetIconParams): __Observable<Blob> {
    return this.IconsGetIconResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

namespace IconsService {

  /**
   * Parameters for IconsGetIcon
   */
  export interface IconsGetIconParams {

    /**
     * The desired size of the icon
     */
    size: 'Small' | 'Medium' | 'Large';

    /**
     * GUID of the requested icon
     */
    iconId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { IconsService }